export const STORAGE_KEYS = {
  token: "TOKEN",
  tempToken: "TEMP_TOKEN",
  credentials: "CREDENTIALS",
  location: "LOCATION",
  userData: "USER_DATA",
  fcmToken: "FCM_TOKEN",
  USER_ROLE: "USER_ROLE",
  WalletAddress: "WALLET_ADDRESS",
  tutorId: "id",
  // email: string;
  user_role: "USER_ROLE",
  full_name: "FULL_NAME",
  PHONE_NO: "PHONE_NO",
  COUNTRY_CODE: "COUNTRY_CODE",
  PROFILE_STATUS: "PROFILE_STATUS",
  currency: "CURRENCY",
  language: "LANGUAGE",
  // token: string;
};
